import _ from 'lodash';
import moment from 'moment';

const headerStyle = () => {
    return {
        borderColor: '#a81933'
    };
};

const columnStyle = () => {
    return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    };
};

const typeFormatter = (row) => {
    if (row && _.isArray(row.Franchises) && row.Franchises.length > 0) {
        const franchises = row.Franchises.map((franchise) => {
            return _.isEmpty(franchise.Franchise)
                ? _.isEmpty(franchise.FranchiseNewsType)
                    ? null
                    : franchise.FranchiseNewsType.Name
                : franchise.Franchise.InternalId;
        });

        return franchises.join(", ");
    } else {
        return 'Incomplete';
    }
};

export const columns = [
    {
        dataField: 'Title',
        text: 'Title',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {
        dataField: 'Franchises',
        text: 'News Type',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle,
        formatter: (_cell, row) => {
            return typeFormatter(row);
        }
    },
    {
        dataField: 'CreatedOn',
        text: 'Created On',
        sort: true,
        headerStyle: headerStyle,
        formatter: (_cell, row) => {
            return moment(row.CreatedOn).format('MM/DD/YYYY')
        }
    },
];

export const sorting = [{
    dataField: 'createdOn',
    order: 'desc'
}];